import { Injectable } from '@angular/core';
import {
  EditarPerfilUsuarioRequest,
  EditarPerfilUsuarioResponse,
  InserirUsuarioInput,
  SelecionarUsuarioInput,
  SelecionarUsuarioOutput,
  Usuario
} from 'src/app/@shared/models/usuario.model';
import { Observable } from 'rxjs';
import { Pagination } from 'src/app/@shared/models/pagination.model';
import { Perfil } from 'src/app/@shared/models/perfil.model';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { HttpHelperService } from '../http-helper/http-helper.service';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};


@Injectable({
  providedIn: 'root'
})
export class UsuarioService {
  constructor(
    private httpClient: HttpClient,
    private http: HttpHelperService
  ) { }

  getProfileList(): Observable<Perfil[]> {
    return this.httpClient.get<Perfil[]>(
      `PerfilAcesso/ListarTodosPerfisCadastrados/`, httpOptions
    );
  }

  getAllActiveUsers(): Observable<HttpResponse<any[]>> {
    return this.httpClient.get<any[]>(`Usuario`, { observe: 'response' });
  }

  getUserProfileList(req?: UsuarioListRequest): Observable<Usuario[]> {
    return this.http.get<Usuario[]>('PerfilAcesso/ListarPerfilAcessoUsuario', req);
  }

  removeUserProfile(userId: number): Observable<any> {
    return this.httpClient.delete<any>(
      `PerfilAcesso/ExcluirPerfilAcessoUsuario/${userId}`
    );
  }

  editUserProfile(obj: EditarPerfilUsuarioRequest): Observable<EditarPerfilUsuarioResponse> {
    return this.httpClient.post<EditarPerfilUsuarioResponse>(
      `PerfilAcesso/InserirPerfilAcessoUsuario`, obj, httpOptions
    );
  }

  inserirUsuario(usuario: InserirUsuarioInput): Observable<any> {
    return this.httpClient.post<any>(`Usuario/InserirUsuario`, usuario, httpOptions);
  }

  atualizarUsuario(usuario: InserirUsuarioInput): Observable<any> {
    return this.httpClient.put<any>(`Usuario/AtualizarUsuario`, usuario, httpOptions);
  }

  selecionarUsuario(codigoUsuario: SelecionarUsuarioInput): Observable<SelecionarUsuarioOutput> {
    return this.httpClient.get<SelecionarUsuarioOutput>(
      `Usuario/SelecionarUsuario/${codigoUsuario}`,
      httpOptions
    );
  }

  public exportarExcel(obj: any): Observable<any> {
    const filter = `${obj.usuario ? `usuario=${obj.usuario}&` : ''}` +
    `${obj.perfilAcessoId ? `perfilAcessoId=${obj.perfilAcessoId}&` : ''}` +
    `${obj.clienteId ? `clienteId=${obj.clienteId}&` : ''}` +
    `${obj.ApenasUsuarioComPerfilAcesso ? `ApenasUsuarioComPerfilAcesso=${obj.ApenasUsuarioComPerfilAcesso}&` : ''}` +
    `${obj.nome ? `nome=${obj.nome}&` : ''}` +
    `${obj.filialId ? `filialId=${obj.filialId}&` : ''}` +
    `${obj.agenteId ? `agenteId=${obj.agenteId}&` : ''}` +
    `${obj.clienteId ? `clienteId=${obj.clienteId}&` : ''}` +
    `${obj.status ? `status=${obj.status}&` : ''}` +
    `${obj.paginaAtual ? `paginaAtual=${obj.paginaAtual}&` : ''}` +
    `${obj.itensPorPagina ? `itensPorPagina=${obj.itensPorPagina}&` : ''}` +
    `${obj.funcionalidades ? `funcionalidades=${obj.funcionalidades}` : ''}`;
    return this.http.get<any>(`PerfilAcesso/ExportarPerfilAcessoUsuario?${filter}`, httpOptions);
  }

  public exportarExcelPermissoesUsuario(obj: any): Observable<any> {
    const filter = `${obj.usuario ? `usuario=${obj.usuario}&` : ''}` +
    `${obj.perfilAcessoId ? `perfilAcessoId=${obj.perfilAcessoId}&` : ''}` +
    `${obj.clienteId ? `clienteId=${obj.clienteId}&` : ''}` +
    `${obj.ApenasUsuarioComPerfilAcesso ? `ApenasUsuarioComPerfilAcesso=${obj.ApenasUsuarioComPerfilAcesso}&` : ''}` +
    `${obj.nome ? `nome=${obj.nome}&` : ''}` +
    `${obj.filialId ? `filialId=${obj.filialId}&` : ''}` +
    `${obj.agenteId ? `agenteId=${obj.agenteId}&` : ''}` +
    `${obj.clienteId ? `clienteId=${obj.clienteId}&` : ''}` +
    `${obj.status ? `status=${obj.status}&` : ''}` +
    `${obj.funcionalidades ? `funcionalidades=${obj.funcionalidades}` : ''}`;
    return this.http.get<any>(`PerfilAcesso/ExportarPerfilAcessoPermissoesUsuario?${filter}`, httpOptions);
  }

}

export class UsuarioListRequest implements Pagination {
  paginaAtual: number = 1;
  itensPorPagina: number = 10;
  usuario?: string;
  perfilAcessoId?: number;
  ApenasUsuarioComPerfilAcesso?: boolean;
  nome?: string;
  filialId?: number;
  agenteId?: number;
  clienteId?: number;
  status?: boolean;
  funcionalidades?: string;
}
